<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!--  <keep-alive>
           <router-view include="home,video"></router-view>
         </keep-alive> -->
    </div>
</template>

<script>
    const requestConfig = require('../bin/config');
    process.appDomain = requestConfig.appDomain;
    process.staticDomain = requestConfig.staticDomain;

    // console.log(typeof apiDomain)
    global.apiDomain = '';
    // global.apiDomain =  '//test-api.allfootballapp.com'
    // api_config.domain

    export default {
        name: 'App',
        metaInfo: {
            title: 'All Football'
        },
        created: function () {
        },
        mounted: function () {
        },
        methods: {}
    };
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?392c0da6